import { gql } from "@apollo/client";
import sessionCrudResultFragment from "./sessionCrudResult.fragment.graphql";

export const sessionsCrud = gql`
  mutation ($originId: ID!, $scenarioId: ID!, $input: SessionCrudInput!) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      sessionsCrud(input: $input) {
        ...SessionCrudResultFields
      }
      __typename
    }
  }
  ${sessionCrudResultFragment}
`;
